module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.eot?60f4d0dcf78754c11702bf144047e7d7";